var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelfRegBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1366,
    height: 956,
    viewBox: "0 0 1366 956",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artwork_30",
    "data-name": "Artwork 30",
    transform: "translate(683 478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42360",
    "data-name": "Group 42360",
    transform: "translate(-683 -478)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22502",
    "data-name": "Rectangle 22502",
    width: 1366,
    height: 956,
    transform: "translate(0)",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124430",
    "data-name": "Path 124430",
    d: "M794.24,851.785c-89.5-27.692-185.366-28.644-279.378-34.377s-190.914-17.5-271.6-63.493C177.97,716.7,127.453,659.291,61.986,622.342A315.738,315.738,0,0,0,0,595.775V956H956.634C917.338,906.777,857.053,871.219,794.24,851.785Z",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124431",
    "data-name": "Path 124431",
    d: "M1121.842,158.831c37.3,47.651,82.761,88.784,111.61,142.72,27.12,50.7,37.7,109.257,48.779,166.441s23.638,115.633,53.9,164.265A199.628,199.628,0,0,0,1366,669.485V0H1063.759C1069.42,56.6,1093.687,122.868,1121.842,158.831Z",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124432",
    "data-name": "Path 124432",
    d: "M1178.318,433.065l5.541-2.477,1.1-5.969a.833.833,0,0,1,1.439-.407l4.068,4.505,6.018-.8a.834.834,0,0,1,.832,1.243l-3.027,5.261,2.617,5.476a.834.834,0,0,1-.925,1.176l-5.939-1.253-4.4,4.181a.834.834,0,0,1-1.4-.516l-.643-6.036-5.337-2.892A.834.834,0,0,1,1178.318,433.065Z",
    fill: "#19a2dc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124433",
    "data-name": "Path 124433",
    d: "M1216.759,499.125l4.433-1.982.882-4.775a.667.667,0,0,1,1.151-.326l3.254,3.6,4.814-.638a.668.668,0,0,1,.666.995l-2.422,4.209,2.094,4.381a.667.667,0,0,1-.74.941l-4.751-1-3.52,3.345a.667.667,0,0,1-1.123-.413l-.514-4.829-4.27-2.313A.667.667,0,0,1,1216.759,499.125Z",
    fill: "#ff7f32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124434",
    "data-name": "Path 124434",
    d: "M42.944,291.961l4.979.281,3.054-3.943a.685.685,0,0,1,1.2.245l1.272,4.822,4.693,1.686a.685.685,0,0,1,.14,1.221l-4.193,2.7-.154,4.984a.685.685,0,0,1-1.118.51l-3.863-3.153-4.788,1.394a.685.685,0,0,1-.83-.906l1.805-4.648-2.806-4.123A.686.686,0,0,1,42.944,291.961Z",
    fill: "#00a3e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124435",
    "data-name": "Path 124435",
    d: "M472.444,627.137l4.979.28,3.053-3.942a.686.686,0,0,1,1.2.245l1.272,4.822,4.693,1.686a.685.685,0,0,1,.139,1.221l-4.193,2.7-.153,4.985a.685.685,0,0,1-1.118.51l-3.863-3.154-4.788,1.395a.686.686,0,0,1-.831-.906l1.806-4.649-2.806-4.122A.685.685,0,0,1,472.444,627.137Z",
    fill: "#ff7f32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124436",
    "data-name": "Path 124436",
    d: "M1252.406,812.98a3.316,3.316,0,0,1-1.721-3.537L1252.748,798l-11.517-2.076a3.332,3.332,0,0,1,1.184-6.557l11.517,2.076L1256,780.01a3.33,3.33,0,0,1,3.869-2.689l.329.059a3.326,3.326,0,0,1,2.684,3.869l-2.064,11.438,11.517,2.076a3.332,3.332,0,0,1-1.184,6.558l-11.516-2.076-2.064,11.437a3.33,3.33,0,0,1-3.869,2.688l-.327-.059A3.3,3.3,0,0,1,1252.406,812.98Z",
    fill: "#00a3e0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42346",
    "data-name": "Group 42346"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124437",
    "data-name": "Path 124437",
    d: "M202.8,919.951c-21.329-45.626-59.743-118.628-87.893-120.388,0,0,15.381,61.856-17.3,58.012S59.149,872.955,74.53,894.1,7.238,955.936,7.238,955.936H179.663Z",
    fill: "#505050",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42345",
    "data-name": "Group 42345"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124438",
    "data-name": "Path 124438",
    d: "M146.332,822.471c-.111-.135-.221-.265-.332-.4C146.111,822.206,146.221,822.336,146.332,822.471Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124439",
    "data-name": "Path 124439",
    d: "M144.353,820.11c-.168-.2-.336-.394-.5-.589C144.017,819.716,144.185,819.913,144.353,820.11Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124440",
    "data-name": "Path 124440",
    d: "M148.736,825.474c-.161-.205-.321-.411-.482-.614C148.415,825.063,148.575,825.269,148.736,825.474Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124441",
    "data-name": "Path 124441",
    d: "M139.978,815.229c-.169-.178-.338-.356-.507-.532C139.64,814.873,139.809,815.051,139.978,815.229Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124442",
    "data-name": "Path 124442",
    d: "M141.921,817.33c-.058-.065-.116-.126-.174-.19C141.8,817.2,141.863,817.265,141.921,817.33Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124443",
    "data-name": "Path 124443",
    d: "M74.53,894.1C59.149,872.955,64.917,853.73,97.6,857.575s17.3-58.011,17.3-58.012h0C73.888,797,66.568,855.955,35.437,863.651c-13.2,3.264-25.065,10.6-35.437,19.774v72.511H7.238S89.911,915.253,74.53,894.1Z",
    fill: "#606060",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124444",
    "data-name": "Path 124444",
    d: "M159.556,840.506l-.518-.771C159.211,839.992,159.384,840.248,159.556,840.506Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124445",
    "data-name": "Path 124445",
    d: "M157.422,837.355c-.117-.17-.234-.343-.351-.513C157.188,837.012,157.3,837.185,157.422,837.355Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124446",
    "data-name": "Path 124446",
    d: "M155.164,834.116c-.16-.227-.321-.45-.481-.675C154.843,833.666,155,833.89,155.164,834.116Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124447",
    "data-name": "Path 124447",
    d: "M137.538,812.725l.094.094Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124448",
    "data-name": "Path 124448",
    d: "M150.753,828.088c-.144-.19-.287-.376-.431-.564C150.466,827.712,150.61,827.9,150.753,828.088Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124449",
    "data-name": "Path 124449",
    d: "M153.1,831.247c-.144-.2-.289-.4-.433-.594C152.811,830.849,152.956,831.049,153.1,831.247Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124450",
    "data-name": "Path 124450",
    d: "M161.662,843.7l-.213-.329Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124451",
    "data-name": "Path 124451",
    d: "M128.925,805.36c.126.09.253.186.38.277C129.178,805.546,129.051,805.45,128.925,805.36Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124452",
    "data-name": "Path 124452",
    d: "M116.631,799.768c.152.025.305.052.458.081C116.936,799.82,116.783,799.793,116.631,799.768Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124453",
    "data-name": "Path 124453",
    d: "M133.2,808.717c.092.079.185.164.277.244C133.387,808.881,133.294,808.8,133.2,808.717Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124454",
    "data-name": "Path 124454",
    d: "M135.132,810.437c.167.153.334.306.5.462C135.466,810.743,135.3,810.59,135.132,810.437Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124455",
    "data-name": "Path 124455",
    d: "M130.86,806.807c.156.122.312.242.468.366C131.172,807.049,131.016,806.929,130.86,806.807Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124456",
    "data-name": "Path 124456",
    d: "M118.644,800.2c.072.019.143.033.214.053C118.787,800.233,118.716,800.219,118.644,800.2Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124457",
    "data-name": "Path 124457",
    d: "M120.623,800.829c.152.056.3.116.456.175C120.927,800.945,120.775,800.885,120.623,800.829Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124458",
    "data-name": "Path 124458",
    d: "M122.586,801.64c.113.051.226.1.338.151C122.812,801.737,122.7,801.691,122.586,801.64Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124459",
    "data-name": "Path 124459",
    d: "M124.726,802.712c.144.079.289.164.434.245C125.015,802.876,124.87,802.791,124.726,802.712Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124460",
    "data-name": "Path 124460",
    d: "M126.669,803.856c.139.088.278.172.418.261C126.947,804.028,126.808,803.944,126.669,803.856Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124461",
    "data-name": "Path 124461",
    d: "M190.08,893.824q-.308-.607-.618-1.216Q189.773,893.217,190.08,893.824Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124462",
    "data-name": "Path 124462",
    d: "M191.717,897.064l-.576-1.141Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124463",
    "data-name": "Path 124463",
    d: "M186.323,886.517l-.6-1.141Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124464",
    "data-name": "Path 124464",
    d: "M193.682,901.006q-.318-.642-.638-1.284Q193.365,900.366,193.682,901.006Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124465",
    "data-name": "Path 124465",
    d: "M188.179,890.1q-.266-.516-.532-1.032Q187.914,889.586,188.179,890.1Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124466",
    "data-name": "Path 124466",
    d: "M184.465,882.976c-.14-.265-.279-.53-.42-.8C184.186,882.446,184.325,882.711,184.465,882.976Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124467",
    "data-name": "Path 124467",
    d: "M195.192,904.067l-.609-1.237Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124468",
    "data-name": "Path 124468",
    d: "M201.73,917.676c-.243-.516-.49-1.038-.737-1.561C201.24,916.638,201.487,917.16,201.73,917.676Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124469",
    "data-name": "Path 124469",
    d: "M200.4,914.87l-.709-1.492C199.933,913.879,200.168,914.374,200.4,914.87Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124470",
    "data-name": "Path 124470",
    d: "M198.553,910.994c-.224-.468-.452-.94-.68-1.412C198.1,910.053,198.329,910.526,198.553,910.994Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124471",
    "data-name": "Path 124471",
    d: "M197.129,908.043c-.223-.461-.445-.92-.671-1.384C196.683,907.123,196.906,907.582,197.129,908.043Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124472",
    "data-name": "Path 124472",
    d: "M218.725,955.936s-6.451-15.794-16.56-37.333l.632,1.348-23.134,35.985Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124473",
    "data-name": "Path 124473",
    d: "M174.3,864.473c-.151-.264-.3-.526-.455-.79Q174.076,864.077,174.3,864.473Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124474",
    "data-name": "Path 124474",
    d: "M172.416,861.208q-.26-.442-.517-.886Q172.157,860.764,172.416,861.208Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124475",
    "data-name": "Path 124475",
    d: "M170.094,857.263c-.117-.2-.235-.39-.351-.586C169.859,856.873,169.977,857.067,170.094,857.263Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124476",
    "data-name": "Path 124476",
    d: "M165.806,850.212l-.154-.245Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124477",
    "data-name": "Path 124477",
    d: "M168.2,854.114q-.267-.44-.533-.878Q167.933,853.674,168.2,854.114Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124478",
    "data-name": "Path 124478",
    d: "M180.575,875.718q-.235-.435-.472-.869Q180.34,875.283,180.575,875.718Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124479",
    "data-name": "Path 124479",
    d: "M182.433,879.156l-.568-1.056Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124480",
    "data-name": "Path 124480",
    d: "M163.909,847.2q-.27-.424-.539-.846Q163.64,846.771,163.909,847.2Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124481",
    "data-name": "Path 124481",
    d: "M176.549,868.435c-.167-.3-.333-.595-.5-.892C176.216,867.84,176.382,868.138,176.549,868.435Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124482",
    "data-name": "Path 124482",
    d: "M178.419,871.785l-.517-.93Z",
    fill: "#606060",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_124483",
    "data-name": "Path 124483",
    d: "M384.069,955.936H66.2s19.868-73.367,131.379-109.9c71.46-23.41,89.081-92.926,128.814-94.208s88.44,59.268,121.765,109.256,57.037,94.54,57.037,94.54Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124484",
    "data-name": "Path 124484",
    d: "M340.808,753.872c-9.74,8.208-12.925,30.657-6.231,45.528,18.378,40.823,36.894,80.8-16.987,78.139-39.331-1.943-57.167,69.376-49.828,78.4H384.069l121.124-.309s-23.713-44.552-57.037-94.54C418.767,817,377.418,764.732,340.808,753.872Z",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124485",
    "data-name": "Path 124485",
    d: "M66.2,955.936s32.829-21.774,49.815-18.377,40.769,18.119,63.418,13.589,23.781-28.311,41.9-26.046S255.3,955.936,255.3,955.936Z",
    fill: "#585858"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124486",
    "data-name": "Path 124486",
    d: "M681.431,955.936c-1.281-3.845-110.229-88.44-160.216-89.721s-137.146,89.721-137.146,89.721Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124487",
    "data-name": "Path 124487",
    d: "M521.7,866.054c-.453-.012-.915,0-1.372,0-6.694,5.561-11.42,12.16-10.8,19.554,1.922,23.072,30.761,15.381,59.6,32.684s-3.846,37.48-3.846,37.48H681.913l-11.064-9.666C641.694,923.027,562.272,867.095,521.7,866.054Z",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124488",
    "data-name": "Path 124488",
    d: "M623.255,841.651c-19.373-1.761-27.232,97.258,0,97.258S644.651,843.6,623.255,841.651Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124489",
    "data-name": "Path 124489",
    d: "M672.973,862.247c-16.629-2.078-39.8,75.414,0,75.414S689.731,864.343,672.973,862.247Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124490",
    "data-name": "Path 124490",
    d: "M228.621,888.7c-11.385-1.035-16,57.157,0,57.157S241.2,889.842,228.621,888.7Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124491",
    "data-name": "Path 124491",
    d: "M261.793,909.622c-7.946-.993-19.016,36.031,0,36.031S269.8,910.623,261.793,909.622Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124492",
    "data-name": "Path 124492",
    d: "M303.928,895.669c9.888-.9,13.9,49.646,0,49.646S293.006,896.662,303.928,895.669Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124493",
    "data-name": "Path 124493",
    d: "M332.688,920.69c5.9-.738,14.123,26.76,0,26.76S326.741,921.434,332.688,920.69Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124494",
    "data-name": "Path 124494",
    d: "M498.018,955.961s1.222-11.607-1.832-11.607-4.277,11.607-4.277,11.607Z",
    fill: "#8a9cb2",
    opacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26709",
    "data-name": "Rectangle 26709",
    width: 1.859,
    height: 31.924,
    transform: "translate(227.652 924.011)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26710",
    "data-name": "Rectangle 26710",
    width: 0.93,
    height: 20.769,
    transform: "translate(261.118 935.167)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26711",
    "data-name": "Rectangle 26711",
    width: 0.93,
    height: 20.769,
    transform: "translate(330.839 935.167)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26712",
    "data-name": "Rectangle 26712",
    width: 1.859,
    height: 24.488,
    transform: "translate(302.95 931.448)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26713",
    "data-name": "Rectangle 26713",
    width: 3.741,
    height: 54.185,
    transform: "translate(669.881 901.494)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26714",
    "data-name": "Rectangle 26714",
    width: 3.438,
    height: 77.882,
    transform: "translate(621.242 877.796)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124495",
    "data-name": "Path 124495",
    d: "M557.745,844.458c6.777-.616,9.527,34.026,0,34.026S550.26,845.139,557.745,844.458Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124496",
    "data-name": "Path 124496",
    d: "M540.351,851.664c5.817-.728,13.925,26.383,0,26.383S534.488,852.4,540.351,851.664Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26715",
    "data-name": "Rectangle 26715",
    width: 1.309,
    height: 20.944,
    transform: "translate(541.433 888.204) rotate(180)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_26716",
    "data-name": "Rectangle 26716",
    width: 1.548,
    height: 29.235,
    transform: "translate(558.451 886.339) rotate(180)",
    fill: "#505050"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124497",
    "data-name": "Path 124497",
    d: "M538.793,955.936c-.031-.267-.892-7.6-3.394-6.77-1.984.661-3.448,4.913-4,6.77Z",
    fill: "#8a9cb2",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124498",
    "data-name": "Path 124498",
    d: "M560.012,955.936c-.34-3.3-1.487-11.866-4.229-11.866-3.358,0-5.882,11.595-5.94,11.866Z",
    fill: "#99b1c9",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124499",
    "data-name": "Path 124499",
    d: "M523.511,955.936c.027-.272,1.66-16.112-2.551-16.112s-5.914,15.84-5.943,16.112Z",
    fill: "#819ec9",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124500",
    "data-name": "Path 124500",
    d: "M484.494,955.871c-.035-.267-1.025-7.587-3.512-6.71-1.971.7-3.361,4.972-3.882,6.839Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124501",
    "data-name": "Path 124501",
    d: "M291.064,955.936c-1.107-6.165-3.928-19.839-7.171-19.839-3.55,0-7.587,15.221-8.729,19.839Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124502",
    "data-name": "Path 124502",
    d: "M191.248,955.936c-.885-5.257-3.126-16.112-6.561-16.112-3.675,0-7.221,11.7-8.428,16.112Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124503",
    "data-name": "Path 124503",
    d: "M162,955.936c-.5-3.271-1.888-10.187-4.5-9.317-2.749.915-4.755,7.02-5.421,9.317Z",
    fill: "#494949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124504",
    "data-name": "Path 124504",
    d: "M142.207,955.936c.291-6.583.485-21.774-3.951-21.774-4.644,0-7.632,16.013-8.556,21.774Z",
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_124505",
    "data-name": "Path 124505",
    d: "M610.789,660.092a43.181,43.181,0,0,0-15.614,2.9,43.306,43.306,0,0,1,0,80.774,43.3,43.3,0,1,0,15.614-83.678Z",
    fill: "#ff7f32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124506",
    "data-name": "Path 124506",
    d: "M497.466,760.983a18.338,18.338,0,0,1,22.476-13.615,26.986,26.986,0,0,1,32.449-14.334,33.244,33.244,0,0,1,59.713,5.808A22.8,22.8,0,0,1,646,758.77c0,.747-.038,1.485-.109,2.213Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124507",
    "data-name": "Path 124507",
    d: "M971.324,800.519a12.783,12.783,0,0,0-15.67-9.492,18.816,18.816,0,0,0-22.624-9.994,23.178,23.178,0,0,0-41.632,4.049,15.9,15.9,0,0,0-23.629,13.894c0,.521.027,1.035.076,1.543Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_42357",
    "data-name": "Group 42357",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42347",
    "data-name": "Group 42347"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124508",
    "data-name": "Path 124508",
    d: "M736.614,541.25c2.573,0,2.578-4,0-4s-2.578,4,0,4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42348",
    "data-name": "Group 42348"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124509",
    "data-name": "Path 124509",
    d: "M145.045,396.572c2.574,0,2.579-4,0-4s-2.578,4,0,4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42349",
    "data-name": "Group 42349"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124510",
    "data-name": "Path 124510",
    d: "M229.2,620c3.861,0,3.867-6,0-6s-3.867,6,0,6Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42350",
    "data-name": "Group 42350"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124511",
    "data-name": "Path 124511",
    d: "M71.039,551.225c5.147,0,5.156-8,0-8s-5.156,8,0,8Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42351",
    "data-name": "Group 42351"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124512",
    "data-name": "Path 124512",
    d: "M1011.455,732.111c5.147,0,5.156-8,0-8s-5.156,8,0,8Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42352",
    "data-name": "Group 42352"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124513",
    "data-name": "Path 124513",
    d: "M1204.532,725.643c2.574,0,2.578-4,0-4s-2.578,4,0,4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42353",
    "data-name": "Group 42353"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124514",
    "data-name": "Path 124514",
    d: "M1150.723,882.035c2.574,0,2.578-4,0-4s-2.578,4,0,4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42354",
    "data-name": "Group 42354"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124515",
    "data-name": "Path 124515",
    d: "M109.218,181c2.573,0,2.578-4,0-4s-2.579,4,0,4Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42355",
    "data-name": "Group 42355"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124516",
    "data-name": "Path 124516",
    d: "M1310.839,280.143c4.505,0,4.512-7,0-7s-4.511,7,0,7Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_42356",
    "data-name": "Group 42356"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124517",
    "data-name": "Path 124517",
    d: "M757.437,894.951c4.5,0,4.512-7,0-7s-4.512,7,0,7Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "VQhVNn.tif"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42358",
    "data-name": "Group 42358"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124518",
    "data-name": "Path 124518",
    d: "M1198.646,177.534a2.452,2.452,0,0,1,3.1-.981c1.159.374,2.345.668,3.525.973a2.328,2.328,0,0,1,1.834,1.982c.522,2.693,1.068,5.381,1.6,8.072.033.164.074.328.135.594.686-1.124,1.325-2.165,1.958-3.209q5.764-9.493,11.515-18.995a2.556,2.556,0,0,1,2.437-1.387l15.318,4.2c.182.124.373.238.546.375a2.193,2.193,0,0,1-1.91,3.844c-1.082-.277-2.156-.586-3.233-.881l-9.495-2.6-.564-.154c-1.145,1.886-2.272,3.746-3.4,5.6q-6.126,10.094-12.254,20.186a2.226,2.226,0,0,1-2.411,1.191,2.25,2.25,0,0,1-1.768-1.917q-1.24-6.208-2.463-12.422a.709.709,0,0,0-.622-.673c-.621-.132-1.221-.361-1.843-.487a2.5,2.5,0,0,1-2.251-2.415Z",
    fill: "#ff7f32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124519",
    "data-name": "Path 124519",
    d: "M1232.191,191.748c.683,1.193,1.34,2.318,1.975,3.456a2.2,2.2,0,1,1-3.823,2.172c-.559-.967-1.107-1.939-1.662-2.909-.092-.162-.191-.319-.345-.574-.469.287-.913.571-1.369.836-.7.406-1.394.816-2.106,1.195a2.194,2.194,0,0,1-2.189-3.8c.984-.6,2-1.146,2.994-1.718.161-.092.317-.191.523-.316-.652-1.142-1.287-2.257-1.926-3.371a2.17,2.17,0,0,1-.12-2.164,2.1,2.1,0,0,1,1.89-1.224,2.071,2.071,0,0,1,1.972,1.082c.669,1.139,1.3,2.3,1.974,3.493.172-.082.309-.137.436-.209.942-.534,1.88-1.072,2.821-1.606a2.22,2.22,0,1,1,2.2,3.814C1234.379,190.507,1233.319,191.107,1232.191,191.748Z",
    fill: "#ff7f32"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_124520",
    "data-name": "Path 124520",
    d: "M43.429,453.481a30.47,30.47,0,0,0-14.882,3.861A44.72,44.72,0,0,0,0,430.016v57.047H73.894c.1-.978.146-1.968.146-2.97A30.611,30.611,0,0,0,43.429,453.481Z",
    fill: "#606060",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "XJXA1F.tif",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_42359",
    "data-name": "Group 42359"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124521",
    "data-name": "Path 124521",
    d: "M63.217,717.57a3.6,3.6,0,0,1,1.118-6.309,5.715,5.715,0,0,1,.991-.194q14.735-1.943,29.468-3.889a3.783,3.783,0,0,1,3.774,1.337,3.591,3.591,0,0,1-1.847,5.649,6.521,6.521,0,0,1-.993.189q-14.692,1.936-29.385,3.872A3.907,3.907,0,0,1,63.217,717.57Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124522",
    "data-name": "Path 124522",
    d: "M86.594,729.644a5.369,5.369,0,0,1-7.6.917,5.4,5.4,0,1,1,7.6-.917Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124523",
    "data-name": "Path 124523",
    d: "M74.509,695.759a5.4,5.4,0,0,1,8.511,6.646,5.4,5.4,0,1,1-8.511-6.646Z",
    fill: "#606060"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfRegBackground);
export default __webpack_public_path__ + "static/media/SelfReg-Background.04ddbf6279cdf4cb875515d197d66095.svg";
export { ForwardRef as ReactComponent };